import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useApiTranslations} from '../../../../context/ApiTranslationsContext';
import {
  OrganizationUserController,
} from '../../../../api/organization/organization-user.controller';
import {OrganizationUserLicensePermissionModel} from '../../../../model/organization/organization-user-license-permission.model';
import {
  OrganizationUsersPageHooks,
} from './organization-users-page-hooks';

type Props = {
  organizationId: string
  userId: string
}

export type OrganizationUserLicensePermissionDrawerState = {
  permissions: OrganizationUserLicensePermissionModel[]
  isPermissionChecked: (id: string) => boolean
  translateLocal: (key: string, params?: Record<string, unknown>) => string
  translate: (key: string) => string

  handleRowToggle: (id: string) => void
  isRowOpen: (id: string) => boolean

  handleSwitchChange: (id: string | null, value: boolean) => Promise<void>
}

export const useOrganizationUserLicensePermissionDrawerState = ({organizationId, userId}: Props): OrganizationUserLicensePermissionDrawerState => {
  const {t} = useTranslation()
  const {translate: apiTranslate} = useApiTranslations()
  const [openRows, setOpenRows] = useState<Record<string, boolean>>({});

  const [permissions, setPermissions] = OrganizationUsersPageHooks.useOrganizationUserLicensePermissions(userId)

  return {
    permissions: permissions,
    handleSwitchChange: async (id, value) => {
      if(id !== null) {
        await OrganizationUserController.updateOrganizationUserPermission(organizationId, userId, id, value ? 'CREATE' : 'DELETE')
        setPermissions(await OrganizationUsersPageHooks.fetchOrganizationUserLicensePermissions(userId))
      }
    },
    isPermissionChecked: (id) => permissions.map(it => it.featureTemplateId).includes(id),
    translateLocal: (key, params) => t(`organization-users.license-permission-drawer.${key}`, params),
    translate: (key) => apiTranslate(key) || t(key),
    isRowOpen: (id) => openRows[id] || false,
    handleRowToggle: (id) => {
      setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
    },
  }
}